<template>
    <VApp>
        <LoadingDialog ref="loading"/>
        <div v-if="autenticado">
            <NavBar/>
            <v-content>
                <Comanda/>
                <keep-alive>
                    <router-view/>
                </keep-alive>
            </v-content>
        </div>
        <!-- é usado um novo if comparando a variável com === para evitar renderização desse componente com autenticado = null-->
        <div v-if="autenticado === false">
            <BannerErro mensagem="Usuário não está autenticado"/>
        </div>
    </VApp>
</template>

<script>
    import NavBar from "@/layouts/NavBar.vue";
    import BannerErro from "@/components/BannerErro.vue";
    import ApiService from "@/common/api.service";
    import LoadingDialog from '@/components/Dialog/Loading.vue';
    import alerts from '@/common/alerts';
    import * as mutations from '@/plugins/mutations.nomes';
    import Comanda from '@/components/Dialog/Comanda.vue';
    import situacoes from "@/common/situacoes";
    import FormBuilderDialog from "@/components/Formularios/FormBuilderDialog";

    export default {
        name: 'RouterContainer',
        components: {
            NavBar,
            BannerErro,
            LoadingDialog,
            Comanda,
            FormBuilderDialog,
        },
        data: () => ({
            autenticado: null,
            parametros:[],
        }),
        async mounted() {
            await this.autenticar();
        },
        computed:{
            coresAgenda:{
                get() {
                    return this.$store.state.coresAgenda;
                }
            },
        },
        methods: {
            async autenticar() {
                try {
                    let [parametros] = (await this.$refs.loading.aguardarPromises([ApiService.get('parametros')], 'Autenticando')).map(r => r.data);

                    if(parametros.configuracoes == null)
                        this.$store.commit(mutations.INICIALIZAR_CONFIGURACAO_CORES, parametros);

                    let situacaoCores = Object.keys(parametros.configuracoes.cores);
                    let parametrosSituacaoCores = this.sincNovasSituacoes(situacaoCores, parametros.configuracoes.cores);
                    parametros.configuracoes.cores = parametrosSituacaoCores;

                    this.$store.commit(mutations.GRAVAR_PARAMETROS, parametros);
                    this.$store.commit(mutations.ATUALIZAR_CONFIGURACAO, parametros.configuracoes);
                    this.autenticado = true;
                } catch (e) {
                    alerts.exibirErro('Não foi possível se autenticar na agenda', e);
                    this.autenticado = false;
                }
            },
            sincNovasSituacoes(situacaoCores, parametrosSituacaoCores) {
              for (const situacao of situacoes) {
                var novaSituacao = true;

                for (const item of situacaoCores) {
                  if(situacao.nome === item){
                    novaSituacao = false;
                    break;
                  }
                }

                if (novaSituacao)
                  Object.assign(parametrosSituacaoCores, { [situacao.nome]: this.coresAgenda[situacao.nome] } );
              }
              return parametrosSituacaoCores;
            },
        }
    };
</script>

<style scoped>

</style>
